import { common as enCommon } from './en/common';
import { common as ruCommon } from './ru/common';

const resources = {
  en: {
    translation: enCommon,
  },
  ru: {
    translation: ruCommon,
  },
};

export default resources;
